import api from '../utils/axios';

export async function getAppealableLines(claimId) {
  const { data } = await api.get(`/claims/${claimId}/optum/appealable-lines/`);
  return data;
}

export async function createDraft(claimId) {
  const { data } = await api.post(`/claims/${claimId}/claim-actions/`);
  return data;
}

export async function updateDraft(ticketId, payload) {
  const { data } = await api.patch(`/claims/action-tickets/${ticketId}/update/`, payload);
  return data;
}

export async function discardDraft(ticketId) {
  const { data } = await api.post(`/claims/action-tickets/${ticketId}/discard/`);
  return data;
}

export async function submitDraft(ticketId) {
  const { data } = await api.post(`/claims/action-tickets/${ticketId}/submit/`);
  return data;
}

export async function getEligibility(claimId) {
  const { data } = await api.get(`/claims/${claimId}/claim-actions/eligibility/`);
  return data;
}

export async function getTicket(ticketId) {
  const { data } = await api.get(`/claims/action-tickets/${ticketId}/`);
  return data;
}

/**
 * GET /api/v1/documents/patient/<patientId>/documents/?provider_id=<providerId>
 * Returns { documents: [{id, filename, uploaded_at, file_size}, ...] }
 */
export async function getPatientDocuments(patientId, providerId) {
  const { data } = await api.get(`/documents/patient/${patientId}/documents/`, {
    params: { provider_id: providerId },
  });
  return Array.isArray(data?.documents) ? data.documents : [];
}
